module.exports = __webpack_public_path__ + "static/img/contant_5.f0d36c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_13/contant_5.jpg
// module id = JH+e
// module chunks = 0